import { ThemeEvents, VariantUpdateEvent } from '@theme/events'

class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog')
    if (!closestSection) return
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice)

    // Renderiza o parcelamento inicial
    this.renderInstallment()
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog')
    if (!closestSection) return
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice)
  }

  /**
   * Updates the price on variant change
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]')
    const currentPrice = this.querySelector('[ref="priceContainer"]')

    if (!newPrice || !currentPrice) return

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice)
    }

    // Atualiza o parcelamento quando o preço mudar
    this.renderInstallment()
  }

  /**
   * Cria ou atualiza o valor de parcelamento (3x)
   */
  renderInstallment() {
    const priceContainer = this.querySelector('[ref="priceContainer"]')
    if (!priceContainer) return

    // Remove qualquer parcela já existente para não duplicar
    let installmentEl = this.querySelector('.installment')
    if (installmentEl) installmentEl.remove()

    // Extrai valor do preço (remove pontos de milhar e troca vírgula por ponto)
    let priceText = priceContainer.innerText
      .replace(/[^\d.,]/g, '')   // mantém apenas dígitos, vírgula e ponto
      .replace(/\./g, '')        // remove separadores de milhar
      .replace(',', '.')         // troca vírgula decimal por ponto

    let priceValue = parseFloat(priceText)

    if (isNaN(priceValue)) return

    // Calcula em 3x
    let installment = priceValue / 5
    let installmentText = ` ou 5x de R$ ${installment.toFixed(2).replace('.', ',')}`

    // Cria elemento de parcela
    installmentEl = document.createElement('span')
    installmentEl.classList.add('installment')
    installmentEl.innerText = installmentText

    // 👉 insere DENTRO do priceContainer, logo após o preço
    priceContainer.appendChild(installmentEl)
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice)
}
